import React  from 'react';
import '@fontsource/inter';
import '@fortawesome/fontawesome-free/css/all.min.css';

import PageNotSpotted from '../../../Components/PageNotSpotted';
import { GameType } from '../../../Utils';
import './AppRoulette.scss';
import { GameEngine } from '../../../Components/GameEngine';

export const AppRoulette = () => {
  return (
    <>
      <GameEngine
        title='轮盘 Roulette'
        containerClass='homeroulette'
        gameType={GameType.Roulette}
      />
      <PageNotSpotted />
    </>
  );
};
